import { HeaderStyles } from "./Header.styles";
import { HeaderProps } from './Header';
import { Logo, CustomIcon } from 'ams-ui-reactkit';
import clsx from 'clsx';
import { navigate } from "@reach/router";
import { LinearProgress } from "@material-ui/core";
import { StoreContext } from "../../context";
import { useContextSelector } from "@fluentui/react-context-selector";
import { getJourneyName, getStepName } from "../../utils/helpers";
import { phone } from "../../assets/index"
import { getSubpath } from "../../utils/helpers"
import Button from '@material-ui/core/Button';
import { useTheme } from '@material-ui/core/styles';
import React from "react";
import { CityMovingLogo } from "../../assets/index";
import "./header.css";
import PhoneIcon from '@material-ui/icons/Phone';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

declare const window: Window &
	typeof globalThis & {
		analytics: any,
		affirm: any
	}

const HeaderView = ({ logoClick, progressValue, profile, help, helpClick, backNav,showPhone=true }: HeaderProps) => {

	const theme = useTheme();

	const classes = HeaderStyles();
	const [callNo, setCallNo] = React.useState("");

	React.useEffect(() => {
		let phoneNo = sessionStorage?.getItem("phone");
		if (phoneNo) {
			setCallNo(phoneNo)
		} else {
			let phoneNoContext = customerContext?.callPhone
			setCallNo(phoneNoContext)
		}
	},[])
	const appState: any = useContextSelector(StoreContext, store => store?.appState);
	const customerContext: any = useContextSelector(
		StoreContext,
		(store) => store?.appState?.customerJourneyContext
	)

	const currentUrl = window.location.href;
	let subPath = getSubpath(currentUrl)

	const createCall = async (call_number: any) => {
		//let call = call_number.to

		const call = `tel:${call_number}`;

		window.open(`${call}`, "_self");
	};

	const handleCall = () => {
		//let phoneNo = sessionStorage?.getItem("phone")
		let custId = customerContext?.customerDetails?.CustomerID

		if (!custId) {
			custId = JSON.parse(sessionStorage?.getItem('CID')!)
		}
		window.analytics.track('Call Us Clicked', {
			customerId: custId
		});

		createCall(callNo)

		// if (phoneNo) {
		// 	createCall(phoneNo)
		// } else {
		// 	let phoneNoContext = customerContext?.callPhone
		// 	if (phoneNoContext) {
		// 		createCall(phoneNoContext)
		// 	}
		// }
	}
	return (
		<div className={classes.headContainer}>
			<div className={classes.headContainerinr}>
				<div className={clsx(classes.backIconBlock)}>
					{backNav ? <span onClick={() => navigate(-1)}>
					<ArrowBackIcon htmlColor="#075280"/>
					</span> : null}
				</div>
				<div className={classes.logoBlock}>
					<span onClick={() => {
						
						let journeyType = sessionStorage?.getItem("journey")

						let custToken = sessionStorage?.getItem("custToken")
						if (custToken) {
							navigate(`/home?custToken=${custToken}`)
						} else {
							navigate("/home")
						}

						


					}} className={classes.driverLogo}>
						<img src={CityMovingLogo} width={100} />
					</span>
				</div>
				<div className={clsx(classes.phoneIconBlock)} onClick={handleCall}>
					{showPhone && <Button name="phone" id="phone" className={"phoneBtn"}><PhoneIcon htmlColor="#075280"/></Button>}

					{showPhone && <Button name="phone" id="phoneText" className={"phoneText"}>{callNo}</Button>}

				</div>
			</div>
			{progressValue ? <LinearProgress
				variant="determinate"
				value={progressValue || 0}
				color="primary"
				classes={{
					root: classes.linearProgressMain,
					barColorPrimary: classes.linearProgressPrimary,
					determinate: classes.linearProgressDeterminate,
					bar1Determinate: classes.linearProgressbar1Determinate,
				}}
			/> : null}
		</div>
	);
}

export default HeaderView